<template>
  <div class="select-area">
    <div class="select-area-header">
      <div class="search-bar">
        <x-input-search placeholder="搜索" @search="doSearch"></x-input-search>
      </div>
    </div>
    <div class="select-area-body">
      <el-amap
        ref="map"
        vid="amapDemo"
        :zoom="15"
        :events="mapConfig.events"
        :plugin="mapConfig.plugin"
        class="amap-demo"
      >
        <el-amap-marker v-if="marker" :position="marker"></el-amap-marker>
      </el-amap>
    </div>
    <div class="select-area-footer">
      <div class="address-text">
        {{ currentAddress }}
      </div>
      <div class="footer--btn">
        <cube-button primary @click="handleConfirm">
          确定
        </cube-button>
      </div>
    </div>
    <div class="form-select-drawer area-drawer">
      <div v-if="showDrawer" class="form-select-drawer-mask"></div>
      <cube-drawer
        ref="drawer"
        class="select-drawer area-drawer"
        :visible="true"
        :class="showDrawer ? 'show-drawer' : 'hide-drawer'"
        @click.native.prevent="cancel"
      >
        <div slot="title" class="title">
          <!-- <span class="cancel" @click="cancel">取消</span>
          <span class="ok" @click="okEvent">确定</span> -->
        </div>
        <div class="select-body">
          <template v-for="(item, index) in searchOption">
            <div
              :key="index"
              class="select-body-item"
              :class="{ 'is-selected': selectedIndex === index }"
              @click="handlerSelectLocation(index)"
            >
              <div class="area-name">
                {{ item.name }}
              </div>
              <div class="area-address">
                {{ item.address }}
              </div>
            </div>
          </template>
        </div>
        <div class="select-footer">
          <span class="cancel" @click="cancel">取消</span>
          <span class="ok" @click="okEvent">确定</span>
        </div>
      </cube-drawer>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { SET_COMP_VALUE } from '@/store/comp-router.store.js'
import { getLocation } from '@/vender/third-sdk/third-function/get-location.js'
export default {
  data() {
    return {
      areaValue: undefined,
      currentAddress: '',
      selectedIndex: -1,
      searchOption: [],
      compPayloadKey: this.$route.query.key,
      selectedArea: undefined,
      loaded: true,
      marker: undefined,
      mapConfig: {
        events: {
          click: (e) => {
            let { lng, lat } = e.lnglat
            this.marker = [lng, lat]
            this.setCurrentAddress(lng, lat)
          }
        },
        plugin: [
          {
            pName: 'Geolocation',
            showMarker: false,
            showCircle: false,
            enableHighAccuracy: true,
            events: {
              complete: (e) => {
                console.log(e)
              }
            }
          }
        ]
      },
      placeSearch: new AMap.PlaceSearch({})
    }
  },
  computed: {
    ...mapState({
      compPayload: (state) => state.compRouterModule.compPayload
    }),
    widgetConfig() {
      return this.compPayload[this.compPayloadKey].widgetConfig
    },
    showDrawer() {
      return this.searchOption.length !== 0
    },
    value() {
      if (this.areaValue) {
        if (this.showAddress) {
          return (
            ((this.areaValue.province && this.areaValue.province.name) || '') +
            ((this.areaValue.city && this.areaValue.city.name) || '') +
            ((this.areaValue.area && this.areaValue.area.name) || '') +
            ((this.areaValue.address && this.areaValue.address.name) || '')
          )
        } else {
          return (
            ((this.areaValue.province && this.areaValue.province.name) || '') +
            ((this.areaValue.city && this.areaValue.city.name) || '') +
            ((this.areaValue.area && this.areaValue.area.name) || '')
          )
        }
      } else {
        return ''
      }
    },
    showAddress() {
      return this.widgetConfig.areaType === 'AREA_ADDRESS'
    }
  },
  created() {
    this.areaValue = this.compPayload[this.compPayloadKey].value
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value) {
        this.placeSearch.search(this.value, (status, result) => {
          if (result.info === 'OK') {
            if (result.poiList.pois && result.poiList.pois.length > 0) {
              this.currentAddress = this.value
              let { lng, lat } = result.poiList.pois[0].location
              this.marker = [lng, lat]
              this.$refs.map.$$getInstance().setCenter([lng, lat])
            }
          }
        })
      } else {
        getLocation(true).then((resp) => {
          let { lng, lat } = resp
          this.marker = [lng, lat]
          this.setCurrentAddress(lng, lat)
        })
      }
    })
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompValue: SET_COMP_VALUE
    }),
    doSearch(e) {
      if (e) {
        this.placeSearch.search(e, (status, result) => {
          this.searchOption = result.poiList.pois
        })
      }
    },
    clearValue() {
      this.marker = undefined
      this.currentAddress = ''
      this.selectedArea = undefined
    },
    handleConfirm() {
      this.setCompValue({
        key: this.$route.query.key,
        value: this.$lodash.cloneDeep(this.selectedArea)
      })
      this.$router.go(-1)
    },
    setCurrentAddress(lng, lat) {
      this.currentAddress = ''
      if (!this.selectedArea) {
        this.selectedArea = {}
      }
      this.$refs.map.$$getInstance().setCenter([lng, lat])
      const geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: 'all'
      })
      geocoder.getAddress([lng, lat], (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          if (result && result.regeocode) {
            this.currentAddress = result.regeocode.formattedAddress
            this.setAreaValue(result.regeocode.addressComponent, this.currentAddress)
            this.$nextTick()
          }
        }
      })
    },
    setAreaValue(address, name) {
      const adcode = address.adcode
      const firstArea = address.province + address.city + address.district + ''
      const secondArea = name.substring(firstArea.length)
      this.selectedArea = {
        province: {
          code: adcode.substring(0, 2),
          name: address.province
        },
        city: {
          code: adcode.substring(2, 4),
          name: address.city || address.province
        },
        area: {
          code: adcode.substring(4, 6),
          name: address.district
        }
      }
      if (this.showAddress) {
        this.selectedArea = {
          ...this.selectedArea,
          address: {
            name: secondArea
          }
        }
      }
    },

    cancel() {
      this.selectedIndex = -1
      this.searchOption = []
    },
    okEvent() {
      const item = this.searchOption[this.selectedIndex]
      this.marker = [item.location.lng, item.location.lat]
      this.setCurrentAddress(item.location.lng, item.location.lat)
      this.selectedIndex = -1
      this.searchOption = []
    },
    handlerSelectLocation(index) {
      this.selectedIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.select-area {
  width: 100vw;
  height: 100vh;
  background-color: $--app-body-bgColor;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .select-area-header {
    z-index: 300;
  }
  .select-area-body {
    // height: calc(100vh - 7.42rem);
    // overflow-y: auto;
    height: calc(100% - 7.5rem);
    position: fixed;
    bottom: 3.8rem;
    width: 100%;
    // height: 100%;
  }
  .select-area-footer {
    position: fixed;
    bottom: 0;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3.71rem;
    padding: 0 1.14rem;
    box-sizing: border-box;
    background-color: $--app-box-bgColor;
    .error-text {
      color: #f56c6c;
    }
    .address-text {
      white-space: nowrap;
      text-overflow: ellipsis;
      // max-width: ;
      overflow: hidden;
    }
    .footer--icon {
      margin-right: 0.857rem;
      color: $--app-notice-font-color;
      .svg-x-lib-all-checkbox-active {
        color: $--app-primary-color;
      }
    }
    .footer--info {
      flex: 1;
      .footer--help {
        color: $--app-notice-font-color;
      }
    }
    .footer--btn {
      flex: 0 0 4.64rem;
    }
  }
}
.form-select-drawer {
  &.area-drawer {
    // .form-select-drawer-mask {
    //   top: 3.8rem;
    // }
    .show-drawer {
      // top: 3.8rem !important;
      transition: bottom 0.3s ease;
    }
    .hide-drawer {
      bottom: 100vh !important;
      top: 0 !important;
      transition: bottom 0.3s ease;
    }
    .select-drawer {
      &.area-drawer::v-deep {
        .cube-drawer-main {
          top: 0;
          bottom: 60%;
          .cube-drawer-title {
            display: none !important;
          }
        }
      }
    }
    .select-footer {
      padding: 0 1.428571rem;
      height: 3.571429rem;
      line-height: 3.571429rem;
      border-top: 0.071429rem solid #eee;
      display: flex;
      width: calc(100% - 2.857142rem);
      align-items: center;
      justify-content: space-between;
      background: #fff;
      position: absolute;
      bottom: 0;
      font-size: 1.142857rem;
      color: #027aff;
    }
  }
  .select-body {
    bottom: 3.571rem;
    top: 3.64rem;
    border-top: 1px solid #ebeef5;
    .select-body-item {
      border-bottom: 1px solid #ebeef5;
      min-height: 2.29rem;
      width: 100%;
      padding: 0.8rem 0;
      &.is-selected {
        background: #f7f7f7;
      }
      .area-name {
        margin-left: 0.8rem;
        min-height: 1.5rem;
      }
      .area-address {
        margin-left: 0.8rem;
        color: #b2b2b2;
      }
    }
  }
}
</style>
